import { useEffect, useState } from "react";
import { getGeneralSettings } from "../pages/Setting/generalSettingsApi";

export const usePaymentMethodRequirement = () => {
  const [required, setRequired] = useState(true);

  useEffect(() => {
    let active = true;
    getGeneralSettings()
      .then(settings => { if (active) setRequired(settings?.requirePaymentMethod !== false); })
      .catch(() => { /* Fail closed: preserve compulsory payment selection if settings cannot load. */ });
    return () => { active = false; };
  }, []);

  return required;
};
